<div>
  <ul>
    <li *ngFor="let c of categories">{{c.nome}}</li>
  </ul>
</div>